var ctrl = function($scope) {
};

ctrl.$inject = ['$scope'];

tiz.directive('cookieWarningModal', function() {
  return {
    restrict: 'E',
    controller: ctrl,
    scope: {
    },
    templateUrl: require('../templates/cookie_warning_modal.html')
  };
});

